import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
// import './MasterModal.scss'
import "./UserModal.scss";
import {
  addDataFunc,
  languageOptionsUtility,
  projectStackOptionsUtility,
  responsibilityOptionsUtility,
  technologyOptionsUtility,
  updateDataFunc,
} from "../../../customHooks";
import FormikControl from "../../formikcontrols";
import { privateRequest } from "../../../api/apiConfig/privateRequest";
const ProjectModal = ({ isOpen, closeModal, title, data, url, setReload }) => {
  const [error, setError] = useState("");
  const [languageOption, setLanguageOption] = useState([]);
  const [technicalstack, setTechnicalstack] = useState([]);
  const [responsibilityOptions, setResponsibilityOptions] = useState([]);
  var initialValues = {
    name: "",
    responsibilities: [],
    technicalStack: [],
    teamSize: null,
    projectStartDate: "",
    projectEndDate: "",
    description: "",
  };
  var numberReg = /^[1-9][0-9]*$/;
  const [formValues, setFormValues] = useState(initialValues);
  var validationSchema = Yup.object().shape({
    name: Yup.string().required(`Project name is required`).nullable(),
    teamSize: Yup.string()
      .matches(numberReg, "Team size should be valid number")
      .required("Team Size  is required")
      .min(1, "Team size should be atleast 1")
      .nullable(),
    projectStartDate: Yup.string()
      .required("Project start date is  required")
      .nullable(),
    projectEndDate: Yup.string()
      .required("Project end date is required")
      .nullable(),
    description: Yup.string().required("Descripton is required").nullable(),
  });
  //  const getLanguageOptions=async()=>{
  //     if (title == "Responsibility") {
  //       const exOptions = await languageOptionsUtility('name', 'id')
  //       console.log('exOptions', exOptions)
  //       setLanguageOption(exOptions)
  //     }
  //   }
  const getStacks = async () => {
    const stacks = await projectStackOptionsUtility();

    setLanguageOption(stacks);
    getDefaultValue(stacks);
  };
  const getDefaultValue = (stacks) => {
    const defaults = [];
    stacks.filter((option) =>
      option.options.filter((opt) =>
        defaults.push(
          data.technicalStack
            .toString()
            .replace(/,/g, "")
            .split(" ")
            .indexOf(opt.label)
        )
      )
    );
    // console.log("defaults", defaults);
    // console.log(
    //   'data.technicalStack.toString().replace(/,/g, "").split("")',
    //   data.technicalStack.toString().replace(/,/g, "").split(",")
    // );
  };
  const handleSubmit = async (values) => {
    if (data === undefined) {
      addDataFunc(url, values, setReload);

      closeModal();
    } else {
      if (data == values) {
        setError("Please Change The Value");
      } else {
        updateDataFunc(url, values, setReload);
        closeModal();
      }
    }
  };
  // const onChange = async (form,field,option,isMulti) => {

  //   form.setFieldValue(
  //    field.name,option.map(item => item.label)

  // )
  //   const LID = option.map(item => item.value.lId)
  //   const CID = option.map(item => item.value.cId)

  const getreponsibilities = async () => {
    const options = await responsibilityOptionsUtility("name", "name");
    setResponsibilityOptions(options);
  };
  const projectStartDate = (form, field, value) => {
    form.setFieldValue(field.name, value);
  };
  const handleChange = (e) => {};
  const getTechnicalStack = async () => {
    const options = await technologyOptionsUtility("name", "name");
    setTechnicalstack(options);
  };
  useEffect(() => {
    getStacks();
    getTechnicalStack();
    getreponsibilities();
  }, []);

  return (
    <div className="user_modal">
      {isOpen && (
        <Modal
          show={isOpen}
          dialogClassName="userModal"
          contentClassName="userContent"
          backdropClassName="userBackdrop"
          centered
          size="lg"
        >
          <Modal.Header>
            <span className="user_modal__sec--head">
              <span className="highlight">
                {data === undefined ? "Add" : "Edit"}
              </span>{" "}
              {title}
            </span>
          </Modal.Header>
          <Modal.Body style={{ overflow: "scroll", height: 400 }}>
            <Formik
              initialValues={data === undefined ? initialValues : data}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {(formik) => {
                return (
                  <Form className="user_modal__sec--body-form">
                    {/* {console.log("values", formik.values)} */}

                    <FormikControl
                      control="input"
                      label="Title"
                      name="name"
                      required={true}
                    />
                    <FormikControl
                      control="select"
                      isLabel={true}
                      label="Technical Stack"
                      form={formik}
                      isMulti={true}
                      name="technicalStack"
                      options={technicalstack}
                      //onChange={onChange}
                      // selectedValue={}
                    />

                    <FormikControl
                      control="select"
                      label="Responsibilities"
                      form={formik}
                      isLabel={true}
                      name="responsibilities"
                      isMulti={true}
                      //onChange={onChange}
                      options={responsibilityOptions}
                    />

                    <FormikControl
                      control="input"
                      label="Team Size"
                      required={true}
                      name="teamSize"
                    />

                    <FormikControl
                      control="date"
                      label="Project Start"
                      required={true}
                      name="projectStartDate"
                      // onChange={projectStartDate}
                    />
                    <FormikControl
                      control="date"
                      label="Project End"
                      required={true}
                      name="projectEndDate"
                      minDate={
                        formik.values.projectStartDate &&
                        formik.values.projectStartDate
                      }
                      // type="date"
                    />
                    <FormikControl
                      control="textarea"
                      label="Project Description"
                      required={true}
                      name="description"
                    />
                    <div
                      style={{
                        color: "orange",
                        fontSize: "10px",
                        textAlign: "center",
                      }}
                    >
                      {error}
                    </div>
                    <Modal.Footer className="user_modal__sec--body-form-bottom">
                      <Button className="user_modal__sec--btn" type="submit">
                        {data === undefined ? "Add" : "Update"}
                      </Button>
                      <Button
                        className="user_modal__sec--btn modal__sec--btn-close"
                        onClick={closeModal}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Form>
                );
              }}
            </Formik>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default ProjectModal;
